export const selectSelectedLanguage = ({ language }) => language.selected;
export const selectLanguageOptions = ({ language }) => language.options;
